import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type DividendsIconProps = IconProps;

export const DividendsIcon: FC<DividendsIconProps> = ({
  iconColor = '#344054',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00065 12H2.66732C2.3137 12 1.97456 11.8595 1.72451 11.6095C1.47446 11.3594 1.33398 11.0203 1.33398 10.6667V5.33333C1.33398 4.97971 1.47446 4.64057 1.72451 4.39052C1.97456 4.14048 2.3137 4 2.66732 4H13.334C13.6876 4 14.0267 4.14048 14.2768 4.39052C14.5268 4.64057 14.6673 4.97971 14.6673 5.33333V8.66667"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.14286"
    />
    <path
      d="M12 8H12.0067"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.14286"
    />
    <path
      d="M12.666 14.6666V10.6666"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.14286"
    />
    <path
      d="M14.666 12.6666L12.666 10.6666L10.666 12.6666"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.14286"
    />
    <path
      d="M4 8H4.00667"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.14286"
    />
    <path
      d="M7.99935 9.33329C8.73573 9.33329 9.33268 8.73634 9.33268 7.99996C9.33268 7.26358 8.73573 6.66663 7.99935 6.66663C7.26297 6.66663 6.66602 7.26358 6.66602 7.99996C6.66602 8.73634 7.26297 9.33329 7.99935 9.33329Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.14286"
    />
  </svg>
);
